import { cloneDeep } from "lodash-es";
import { reactive, type Ref, toRefs } from "vue";

import VocabService from "@/common/api/vocab.service";
import type { Achievement, OpenedBadge, UnpackedBadge } from "@/common/types/vocab";

import { unpackAchievementBadge } from "./use-vocab-achievements";

interface State {
  isRedemptionModalOpen: boolean;
  badge: UnpackedBadge;
}

const initialState: State = {
  isRedemptionModalOpen: false,
  badge: {} as UnpackedBadge
};

export const useVocabBadges = (achievements: Ref<Achievement[]>) => {
  const state = reactive<State>(cloneDeep(initialState));

  const getActiveAchievement = (): Achievement => {
    const achievement = achievements.value.find((a) => a.badge?.name === state.badge.name);
    if (!achievement) {
      throw Error("Could not find achievement that is being redeemed");
    }

    return achievement;
  };

  const onRedeemClick = (achievement: Achievement) => {
    if (!achievement.badge) {
      return;
    }

    state.isRedemptionModalOpen = true;
    state.badge = unpackAchievementBadge(achievement);
  };

  const onCloseRedemptionModal = () => {
    state.isRedemptionModalOpen = false;
    state.badge = {} as UnpackedBadge;
  };

  const onBadgeRedeem = async () => {
    const achievement = getActiveAchievement();
    const badge: OpenedBadge = (await VocabService.openBadge(state.badge.name)).data.data;

    if (!achievement?.badge) {
      return;
    }

    achievement.badge.openedAt = badge.openedAt;
  };

  return {
    ...toRefs(state),

    onRedeemClick,
    onCloseRedemptionModal,
    onBadgeRedeem
  };
};
